// extracted by mini-css-extract-plugin
export default {"component":"b1mnbO","text":"c1mnbO","iconWrapper":"d1mnbO","arrow":"e1mnbO","branded":"f1mnbO","takeover":"g1mnbO","icon":"h1mnbO","smallUserIcon":"i1mnbO","userIcon":"j1mnbO"};